"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var navbarLink_1 = require("./navbarLink");
var dropDown_1 = require("./dropDown");
var navArrow_1 = require("./navArrow");
var navbarContext_1 = require("./navbarContext");
var styled_1 = __importDefault(require("@emotion/styled"));
var ListItem = styled_1.default.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  flex: 1;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n"], ["\n  position: relative;\n  flex: 1;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n"])));
var DropDownList = styled_1.default.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n"], ["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n"])));
var DropDownListItem = styled_1.default.li(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 64px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: color 0.2s;\n  border-bottom: 1px solid rgb(221, 229, 254);\n\n  &:last-of-type {\n    border-bottom: none;\n    margin-bottom: -16px;\n  }\n\n  &:first-of-type {\n    margin-top: -16px;\n  }\n\n  &:hover {\n    color: \"#ff0063\";\n  }\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 64px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: color 0.2s;\n  border-bottom: 1px solid rgb(221, 229, 254);\n\n  &:last-of-type {\n    border-bottom: none;\n    margin-bottom: -16px;\n  }\n\n  &:first-of-type {\n    margin-top: -16px;\n  }\n\n  &:hover {\n    color: \"#ff0063\";\n  }\n"])));
var LogoIcon = styled_1.default.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: block;\n  width: 44px;\n  height: 32px;\n  padding-right: 4px;\n  padding-left: 8px;\n"], ["\n  display: block;\n  width: 44px;\n  height: 32px;\n  padding-right: 4px;\n  padding-left: 8px;\n"])));
exports.NavItem = function (_a) {
    var item = _a.item, id = _a.id;
    var url = item.url, label = item.label, children = item.children, logo = item.logo;
    var toggleMenu = react_1.useContext(navbarContext_1.NavContext).toggleMenu;
    if (url) {
        return (react_1.default.createElement(ListItem, null,
            react_1.default.createElement(navbarLink_1.Link, { target: "_parent", href: url }, label)));
    }
    return (react_1.default.createElement(ListItem, null,
        react_1.default.createElement(navbarLink_1.Link, { onClick: function (e) {
                e.stopPropagation();
                toggleMenu(id);
            }, style: { paddingRight: 16 } },
            react_1.default.createElement("div", null, label),
            logo ? react_1.default.createElement(LogoIcon, { src: logo }) : null,
            react_1.default.createElement(navArrow_1.NavArrow, null)),
        react_1.default.createElement(dropDown_1.DropDown, __assign({}, { id: id }),
            react_1.default.createElement(DropDownList, null, children.map(function (a) {
                return (react_1.default.createElement(DropDownListItem, { key: "item-" + a.label },
                    react_1.default.createElement(navbarLink_1.Link, { target: "_parent", href: a.url }, a.label)));
            })))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
